<template>
  <div class="navbar">
    <div class="navbar_item" v-for="(item, index) in items" :key="index" :to="item.url" @click="navbarChange(index)">
      <img class="icon" :class="{'activeIcon': navbarIndex == index}" :src="navbarIndex == index ? item.activeIcon : item.normalIcon" />
      <span :class="{'activeColor': navbarIndex == index}">
        <template v-if="userInfo.Type != 3">{{item.text}}</template>
        <template v-if="userInfo.Type == 3">{{item.textEn}}</template>
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import mixin from '../common/mixin/mixins'
export default {
  data() {
    return {
      items: [{
        text: '首页',
        textEn: 'Home',
        isRoleType: false,
        url: '/department',
        normalIcon: require('../assets/images/home_tab_sel_icon@2x.png'),
        activeIcon: require('../assets/images/home_active_icon@2x.png')
      },
      {
        text: '活动',
        textEn: 'Live',
        isRoleType: false,
        url: '/liveList',
        normalIcon: require('../assets/images/live_tab_icon.png'),
        activeIcon: require('../assets/images/live_active_icon.png')
      },
      {
        text: '我的',
        textEn: 'Me',
        isRoleType: true,
        url: '/Personal',
        url2: '/JNJPersonal',
        normalIcon: require('../assets/images/fxdt_tab_personal_icon@2x.png'),
        activeIcon: require('../assets/images/my_active_icon@2x.png')
      }]
    }
  },
  mixins: [mixin],
  computed: {
    ...mapState(["userInfo"]),
    navbarIndex() {
      return this.$store.state.navbarIndex;
    }
  },
  methods: {
    navbarChange(index) {
      // if(this.items[index].isRoleType && this.userInfo.Type == 2) {
      //   this.$router.push(this.items[index].url2);
      //   this.BuriedPoint(1, this.items[index].text, '', this.items[index].url2);
      // } else {
      //   this.$router.push(this.items[index].url);
      //   this.BuriedPoint(1, this.items[index].text, '', this.items[index].url);
      // }
      if(this.navbarIndex != index) {
        if(this.items[index].isRoleType) {
          // if(this.userInfo.Type == 1) {
          //   wx.miniProgram.navigateTo({url: '/pages/personal2/personal2'})
          //   this.BuriedPoint(1, this.items[index].text, '', this.items[index].url);
          // }
          if(this.userInfo.Type == 2) {
            this.$router.push(this.items[index].url2);
            this.BuriedPoint(1, this.items[index].text, '', this.items[index].url2);
          } else {
            this.$router.push(this.items[index].url);
            this.BuriedPoint(1, this.items[index].text, '', this.items[index].url);
          }
        } else {
          this.$router.push(this.items[index].url);
          this.BuriedPoint(1, this.items[index].text, '', this.items[index].url);
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  position: fixed;
  left: 5%;
  bottom: 10px;
  display: flex;
  width: 90%;
  height: 56px;
  border-radius: 56px;
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  box-shadow: 0 1px 10px -4px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  z-index: 997;
  .navbar_item {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex: 1;
    font-size: 12px;
    color: #9B9B9B;
    .icon{
      display: block;
      width: 30px;
      height: 30px;
    }
    .activeColor {
      color: #000000;
    }
  }
}
</style>